import CaretDownIcon from "@/images/icons/caret-down.svg";
import * as Select from "@radix-ui/react-select";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import clsx from "clsx";
import { useState } from "react";
import styles from "./SelectInput.module.scss";

type Option = {
	label: string;
	value: string;
};

interface SelectInputProps extends Omit<Select.SelectProps, "children"> {
	options?: Option[] | null;
	className?: string;
	placeholder?: string;
}

export const SelectInput = ({
	options,
	value,
	className,
	placeholder,
	onValueChange,
	...selectProps
}: SelectInputProps) => {
	const [internalValue, setInternalValue] = useState(value);

	const onChange = (value: string) => {
		if (!value) return;
		setInternalValue(value);
		onValueChange && onValueChange(value);
	};

	return (
		<Select.Root
			{...selectProps}
			value={value}
			onValueChange={onChange}
		>
			<Select.Trigger
				className={clsx(
					styles["select-trigger"],
					className,
					selectProps.disabled && styles["select-trigger--disabled"],
				)}
			>
				<span className={styles["select-trigger__value"]}>
					<Select.Value placeholder={placeholder || "Select an option"}>
						{options?.find(opt => opt.value === internalValue)?.label}
					</Select.Value>
				</span>

				<CaretDownIcon className={styles["select-trigger__icon"]} />
			</Select.Trigger>
			<Select.Content
				className={styles["select-content"]}
				position="popper"
			>
				<ScrollArea.Root
					className={styles["scroll-area"]}
					type="auto"
				>
					<ScrollArea.Viewport className={styles["scroll-area__viewport"]}>
						<Select.Viewport>
							{options?.map((item, i) => (
								<Select.Item
									className={styles["select-content__item"]}
									key={`${item.value} ${i}`}
									value={item.value}
								>
									{item.label}
								</Select.Item>
							))}
						</Select.Viewport>
					</ScrollArea.Viewport>

					<ScrollArea.Scrollbar
						className={styles["scroll-area__scrollbar"]}
						orientation="vertical"
					>
						<ScrollArea.Thumb className={styles["scroll-area__scrollbar__thumb"]} />
					</ScrollArea.Scrollbar>
				</ScrollArea.Root>
			</Select.Content>
		</Select.Root>
	);
};
